/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.1
// source: proto/category.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.proto = require('./category_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CategoryServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.CategoryServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.CreateCategoryRequest,
 *   !proto.proto.CreateCategoryResponse>}
 */
const methodDescriptor_CategoryService_CreateCategory = new grpc.web.MethodDescriptor(
  '/proto.CategoryService/CreateCategory',
  grpc.web.MethodType.UNARY,
  proto.proto.CreateCategoryRequest,
  proto.proto.CreateCategoryResponse,
  /**
   * @param {!proto.proto.CreateCategoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CreateCategoryResponse.deserializeBinary
);


/**
 * @param {!proto.proto.CreateCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CreateCategoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CreateCategoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CategoryServiceClient.prototype.createCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CategoryService/CreateCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_CreateCategory,
      callback);
};


/**
 * @param {!proto.proto.CreateCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CreateCategoryResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CategoryServicePromiseClient.prototype.createCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CategoryService/CreateCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_CreateCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.UpdateCategoryRequest,
 *   !proto.proto.UpdateCategoryResponse>}
 */
const methodDescriptor_CategoryService_UpdateCategory = new grpc.web.MethodDescriptor(
  '/proto.CategoryService/UpdateCategory',
  grpc.web.MethodType.UNARY,
  proto.proto.UpdateCategoryRequest,
  proto.proto.UpdateCategoryResponse,
  /**
   * @param {!proto.proto.UpdateCategoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.UpdateCategoryResponse.deserializeBinary
);


/**
 * @param {!proto.proto.UpdateCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.UpdateCategoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.UpdateCategoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CategoryServiceClient.prototype.updateCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CategoryService/UpdateCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_UpdateCategory,
      callback);
};


/**
 * @param {!proto.proto.UpdateCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.UpdateCategoryResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CategoryServicePromiseClient.prototype.updateCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CategoryService/UpdateCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_UpdateCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.DeleteCategoryRequest,
 *   !proto.proto.DeleteCategoryResponse>}
 */
const methodDescriptor_CategoryService_DeleteCategory = new grpc.web.MethodDescriptor(
  '/proto.CategoryService/DeleteCategory',
  grpc.web.MethodType.UNARY,
  proto.proto.DeleteCategoryRequest,
  proto.proto.DeleteCategoryResponse,
  /**
   * @param {!proto.proto.DeleteCategoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.DeleteCategoryResponse.deserializeBinary
);


/**
 * @param {!proto.proto.DeleteCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.DeleteCategoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.DeleteCategoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CategoryServiceClient.prototype.deleteCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CategoryService/DeleteCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_DeleteCategory,
      callback);
};


/**
 * @param {!proto.proto.DeleteCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.DeleteCategoryResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CategoryServicePromiseClient.prototype.deleteCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CategoryService/DeleteCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_DeleteCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListCategoryRequest,
 *   !proto.proto.ListCategoryResponse>}
 */
const methodDescriptor_CategoryService_ListCategory = new grpc.web.MethodDescriptor(
  '/proto.CategoryService/ListCategory',
  grpc.web.MethodType.UNARY,
  proto.proto.ListCategoryRequest,
  proto.proto.ListCategoryResponse,
  /**
   * @param {!proto.proto.ListCategoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListCategoryResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListCategoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListCategoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CategoryServiceClient.prototype.listCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CategoryService/ListCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_ListCategory,
      callback);
};


/**
 * @param {!proto.proto.ListCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListCategoryResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CategoryServicePromiseClient.prototype.listCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CategoryService/ListCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_ListCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ItemCategoryRequest,
 *   !proto.proto.ItemCategoryResponse>}
 */
const methodDescriptor_CategoryService_ItemCategory = new grpc.web.MethodDescriptor(
  '/proto.CategoryService/ItemCategory',
  grpc.web.MethodType.UNARY,
  proto.proto.ItemCategoryRequest,
  proto.proto.ItemCategoryResponse,
  /**
   * @param {!proto.proto.ItemCategoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ItemCategoryResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ItemCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ItemCategoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ItemCategoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.CategoryServiceClient.prototype.itemCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.CategoryService/ItemCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_ItemCategory,
      callback);
};


/**
 * @param {!proto.proto.ItemCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ItemCategoryResponse>}
 *     Promise that resolves to the response
 */
proto.proto.CategoryServicePromiseClient.prototype.itemCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.CategoryService/ItemCategory',
      request,
      metadata || {},
      methodDescriptor_CategoryService_ItemCategory);
};


module.exports = proto.proto;

